var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    attrs: {
      "aria-label": ((this.isPlaying ? 'Pause' : 'Play') + " instructions"),
      "disabled": !_vm.hasAudioLoaded,
      "id": "toggleAudioButton",
      "tabindex": "8"
    },
    on: {
      "click": _vm.toggleAudio
    }
  }, [_vm.isPlaying ? _c('div', {
    staticClass: "icon-video-pause",
    staticStyle: {
      "height": "40px",
      "width": "40px"
    }
  }) : _c('div', {
    staticClass: "icon-video-play",
    staticStyle: {
      "height": "40px",
      "width": "40px"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }